import {
    TransactionAction,
    TransactionsActions,
} from '../actions/transactions.actions';
import { TransactionsActionsState } from '../state/transactions-actions.state';

export const initialTransactionActionsState: TransactionsActionsState = {
    null: [
        {
            id: 0,
            withdrawId: '',
            dateTime: new Date(),
            status: '',
            metadata: {},
            processId: '',
            hash: '',
            externalWithdrawId: '',
        },
    ],
};

export function transactionActionsReducer(
    state = initialTransactionActionsState,
    action: TransactionAction
) {
    switch (action.type) {
        case TransactionsActions.SuccessGetTransaction:
            const newState: TransactionsActionsState = { ...state };
            newState[action.transactionId] = [...action.actions];
            return newState;
        case TransactionsActions.UpdateTransaction:
            const updatedState: TransactionsActionsState = { ...state };
            updatedState[action.transactionId] = updatedState[action.transactionId].map(transaction => {
                if (transaction.status === action.status) {
                    return {...transaction, ...action.transaction};
                }
                return transaction;
            });
            return updatedState;
        case TransactionsActions.AddTransactionAction:
            const currentState = {...state};
            currentState[action.transactionId] = [...currentState[action.transactionId], action.action];
            return currentState;
        default:
            return state;
    }
}
